import { render } from "./CalendarTile.vue?vue&type=template&id=04ed4de5"
import script from "./CalendarTile.vue?vue&type=script&lang=js"
export * from "./CalendarTile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__